import {PropsWithChildren, useMemo} from 'react';

import {ImageWithFormats} from '@web-landing/strapi/types';

type Props = PropsWithChildren<{
  imageData: ImageWithFormats | null | undefined;
  className?: string;
  as?: React.ElementType;
  style?: React.CSSProperties;
}>;

export default function StrapiBackgroundImage({
  as: Component = 'div',
  imageData,
  className,
  children,
  style,
}: Props) {
  const mergedStyle = useMemo(
    () =>
      (imageData
        ? {
            backgroundImage: `url(${imageData.url})`,
            ...style,
          }
        : style) as React.CSSProperties,
    [imageData, style],
  );

  return (
    <Component className={className} style={mergedStyle}>
      {children}
    </Component>
  );
}
